import script from "./Launch1Day.vue?vue&type=script&setup=true&lang=js"
export * from "./Launch1Day.vue?vue&type=script&setup=true&lang=js"

import "./Launch1Day.vue?vue&type=style&index=0&id=2bed3112&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bed3112"]])

export default __exports__